import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMedia } from 'react-use';
import { toggleBodyOverlay } from 'ck-utils';
import { Modal as BaseModal, Container } from 'ui-base';
import { Icon, Typography } from 'ck-ui';
import styles from './Modal.module.scss';

const Modal = ({
  className,
  children,
  onClose,
  alert,
  isTabletAboveFixedSize,
  isTouchFullScreen,
  show,
  isFixedSize,
  isAdaptive,
  bottomCloseText,
  isTouchXFullScreen,
  isWhiteCloseBtn,
  ...rest }) => {
  toggleBodyOverlay(show, 'modal');
  const isMobile = useMedia('(max-width: 767px)');
  return (
    <BaseModal showClose={false} show={show} onClose={onClose} className={styles.wrapper} {...rest}>
      <Container className={alert ? styles.alert : classnames(styles.container, {
        [styles.tabletAboveFixedSize]: isTabletAboveFixedSize,
        [styles.touchFullScreen]: isTouchFullScreen,
        [styles.touchXFullScreen]: isTouchXFullScreen,
        [styles.fixedSize]: isFixedSize,
        [styles.adaptive]: isAdaptive
      })}
      >
        <div className={classnames(styles.content, className)}>
          {children}
        </div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className={classnames(
              'modal-close',
              'is-large',
              styles.buttonClose,
              { [styles.btnWhite]: isWhiteCloseBtn }
            )}
            aria-label="close"
          />
        )}
      </Container>
      {bottomCloseText && (
        <Typography
          variant="body-xlarge"
          color="white"
          align="centered"
          display="block"
          onClick={onClose}
          className={styles.bottomClose}
        >
          {!isMobile && <Icon name="cross" color="secondary" size="regular" /> }
          <span className={!isMobile ? 'is-inline' : 'is-block'}>{bottomCloseText}</span>
          {isMobile && <Icon name="cross" color="secondary" size="regular" /> }
        </Typography>
      )}
    </BaseModal>
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  closeOnBlur: PropTypes.bool,
  closeOnEsc: PropTypes.bool,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  alert: PropTypes.bool,
  isTabletAboveFixedSize: PropTypes.bool,
  isTouchFullScreen: PropTypes.bool,
  isFixedSize: PropTypes.bool,
  isAdaptive: PropTypes.bool,
  bottomCloseText: PropTypes.string,
  isTouchXFullScreen: PropTypes.bool,
  isWhiteCloseBtn: PropTypes.bool
};

Modal.defaultProps = {
  children: null,
  className: null,
  closeOnBlur: true,
  closeOnEsc: false,
  onClose: null,
  show: false,
  alert: false,
  isTabletAboveFixedSize: false,
  isTouchFullScreen: false,
  isFixedSize: false,
  isAdaptive: false,
  bottomCloseText: null,
  isTouchXFullScreen: false,
  isWhiteCloseBtn: false
};

export { Modal };
